module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/4@2x_5a24954e09178392c753852880e71819.png";